import { l } from '@manychat/manyui'
import { MakeTranslateReturnValue } from '@manychat/manyui/src/utils/localization/format'

export enum SystemFieldId {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  PHONE_US_STATE = 'phone_us_state',
}

export const getEditableSystemFields = () => {
  return [
    { fieldId: SystemFieldId.FIRST_NAME, alwaysShown: true },
    { fieldId: SystemFieldId.LAST_NAME, alwaysShown: true },
    { fieldId: SystemFieldId.EMAIL, alwaysShown: false },
    { fieldId: SystemFieldId.PHONE, alwaysShown: false },
    { fieldId: SystemFieldId.PHONE_US_STATE, alwaysShown: false },
  ]
}

export const SYSTEM_FIELD_DESCRIPTIONS: Record<SystemFieldId, string> = {
  [SystemFieldId.EMAIL]: l.translate('This field is used to send emails to your contacts.'),
  [SystemFieldId.PHONE]: l.translate(
    'This field is used to store phone numbers for SMS marketing. Only full numbers with the country code including “+” are allowed.',
  ),
  [SystemFieldId.PHONE_US_STATE]: l.translate(
    'U.S. state field is defined automatically based on phone number area code.',
  ),
  [SystemFieldId.FIRST_NAME]: l.translate(
    'This field is used to store the first name of your contacts.',
  ),
  [SystemFieldId.LAST_NAME]: l.translate(
    'This field is used to store the last name of your contacts.',
  ),
}

export const SYSTEM_FIELD_TOAST_MESSAGES: Record<SystemFieldId, MakeTranslateReturnValue> = {
  [SystemFieldId.FIRST_NAME]: l.makeTranslate('First name updated'),
  [SystemFieldId.LAST_NAME]: l.makeTranslate('Last name updated'),
  [SystemFieldId.EMAIL]: l.makeTranslate('Email updated'),
  [SystemFieldId.PHONE]: l.makeTranslate('Phone number updated'),
  [SystemFieldId.PHONE_US_STATE]: l.makeTranslate('Phone number area code updated'),
}
